export default __webpack_public_path__ + "static/map_marker_C-eb82aa2561776a154bc07f1023d132c7.png";